export default __webpack_public_path__ + "static/media/icon_keep_working_white.c1d1c9dc.svg";